import React, {useState, useEffect, useReducer} from 'react';
import {API} from 'aws-amplify';
import PropTypes from 'prop-types';
import './securityGroupComparer.css';
import SecGroupContainer from './secGroupContainer/secGroupContainer.js';
import {compareGroups} from '../../universal/utils';

const SecurityGroupsContext = React.createContext('bye');

const SecurityGroupComparer = (props) => {

  const [securityGroups, updateSecurityGroups] = useState([]);
  const [groupId1, updateGroupId1] = useState('');
  const [groupId2, updateGroupId2] = useState('');
  const [groupComparison, updateGroupComparison] = useState(undefined);

  useEffect(() => {
    API.get('WBU', '/securitygroups')
    .then(res => {
      updateSecurityGroups(res);
    })
    .catch(err => {
      console.log(err);
      console.log(JSON.stringify(err));
    });
  }, []);

  useEffect(() => {
    if (groupId1 && groupId2) {
      const group1 = securityGroups.find(group => group.GroupId === groupId1);
      const group2 = securityGroups.find(group => group.GroupId === groupId2);
      const groupComparison = compareGroups(group1, group2);
      updateGroupComparison(groupComparison);
    }
  }, [groupId1, groupId2]);

  const handleUpdateState = payload => {
    if (payload.groupId2) updateGroupId2(payload.groupId2);
    if (payload.groupId1) updateGroupId1(payload.groupId1);
  };

  return (
    <SecurityGroupsContext.Provider value={groupComparison || 'hi'}>
      <div className="SecurityGroupComparerPage">
        <SecGroupContainer securityGroups={securityGroups} chosenGroups={[groupId1, groupId2]} updateParentState={handleUpdateState}/>
      </div>
    </SecurityGroupsContext.Provider>
  );

};

SecurityGroupComparer.propTypes = {

};

export {SecurityGroupComparer as default, SecurityGroupsContext};


// WEBPACK FOOTER //
// ./src/components/content/securityGroupComparer/securityGroupComparer.js